import { i18n } from 'next-i18next'
import { Config } from 'modules/config/state/config-types'
import { FlowStep } from '../../flow-types'
import { INITIAL_INVALID_STEP_INDEX } from './constants'

export const OPTIONAL_CUSTOM_QUESTION_STEP_NAME = 'optionalCustomQuestion'
export const REQUIRED_CUSTOM_QUESTION_STEP_NAME = 'requiredCustomQuestion'

const makeCustomQuestionSteps = (config: Config, required: boolean): FlowStep[] => {
  const t = i18n?.t.bind(i18n) || ((key: string, fallback: string) => fallback)

  return config.questions.custom
    .filter((question) => question.is_required === required)
    .map((question) => {
      const stepName = required
        ? `${REQUIRED_CUSTOM_QUESTION_STEP_NAME}-${question.id}`
        : `${OPTIONAL_CUSTOM_QUESTION_STEP_NAME}-${question.id}`

      return {
        name: stepName,
        enabled: true,
        numVisits: 0,
        title: t('AdditionalDetailsStep.title', 'Additional details'),
        index: INITIAL_INVALID_STEP_INDEX,
        layout: required ? 'flow-two-column' : 'flow-one-column',
      }
    })
}

export default makeCustomQuestionSteps
